<!--- COMPONENTE PCVistaVolcarPartida  ---->
<!---
Descripción del componente:
---------------------------
-

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div
    v-if="partidaSeleccionada != null"
    class="div-componentePCVistaVolcarPartida"
  >
    <!-- Cabecera del detalle -->
    <f7-row>
      <!-- <pre> {{ partidaSeleccionadaLocal.Existencias[0].Partida }}</pre> -->
      <f7-col width="100">
        <span class="span-numeroPartida">
          {{ `${$t('common.batch').toUpperCase()} ${partidaSeleccionada.Serie}/${partidaSeleccionada.Numero}` }}
        </span>
      </f7-col>
    </f7-row>

    <!-- Información detalle -->
    <div
      v-if="existenciaSeleccionada != null"
      class="div-informacionDelDetalle"
    >
      <f7-row>
        <f7-col width="30">
          <span class="span-ttlElemento">
            {{ $t('production.dump.batchDetails.commodity') }}
          </span>
        </f7-col>
        <f7-col width="70">
          <span
            v-if="existenciaSeleccionada.Articulo"
            class="span-textoElemento"
          >
            {{ existenciaSeleccionada.Articulo.Descripcion }}
          </span>
        </f7-col>
      </f7-row>

      <f7-row>
        <f7-col width="30">
          <span class="span-ttlElemento">
            {{ $t('common.pallet') }}
          </span>
        </f7-col>
        <f7-col
          width="70"
        >
          <span
            class="span-textoElemento"
          > {{ existenciaSeleccionada.NumeroSerie }}
          </span>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="30">
          <span class="span-ttlElemento">
            {{ $t('production.dump.batchDetails.packagesNum') }}
          </span>
        </f7-col>
        <f7-col width="70">
          <span
            class="span-textoElemento"
          > {{ existenciaSeleccionada.Cajas }}
          </span>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="30">
          <span class="span-ttlElemento">
            {{ $t('common.quantity') }}
          </span>
        </f7-col>
        <f7-col width="70">
          <span
            class="span-textoElemento"
          > {{ existenciaSeleccionada.Cantidad }} </span>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="30">
          <span class="span-ttlElemento">
            {{ $t('common.netWeight') }}
          </span>
        </f7-col>
        <f7-col width="70">
          <span
            class="span-textoElemento"
          > {{ existenciaSeleccionada.PesoNeto }}
          </span>
        </f7-col>
      </f7-row>
    </div>

    <!-- Botones de volcado -->
    <f7-row class="div-row-botonesDeVolcadoYRecuperado">
      <f7-col
        :width="mostrarOpcionesDeVolcadoRecuperadoParcial ? 50 : 100"
      >
        <f7-button
          fill
          class="btn-color-oscuro-1 btn-tamaño-3"
          @click="VolcadoTotalMercancia()"
        >
          {{ $t('production.dump.batchDetails.btnDumpEverythingText') }}
        </f7-button>
      </f7-col>
      <f7-col
        v-if="mostrarOpcionesDeVolcadoRecuperadoParcial"
        :width="mostrarOpcionesDeVolcadoRecuperadoParcial ? 50 : 100"
      >
        <f7-button
          fill
          class="btn-color-amarillo-1 btn-tamaño-3"
          @click="PrepararVolcadoParcial()"
        >
          {{ $t('production.dump.batchDetails.partialDump.button.text') }}
        </f7-button>
      </f7-col>
    </f7-row>

    <!-- Action para volcado parcial -->
    <f7-actions
      class="actions-1"
      :opened="actionsVolcadoParcial"
      @actions:closed="CerrarActionDetalle()"
    >
      <div class="div-actionsTitulo-2">
        <span class="">
          {{ $t('production.dump.batchDetails.partialDump.actions.title') }}
        </span>
      </div>

      <UCUnidadMedidaKiloYEnvase
        :activo="actionsVolcadoParcial"
        :default-envases="cantidadMaximaEnvasesVolcar"
        :default-kilos="cantidadMaximaKilosVolcar"
        :autocalculo="true"
        modo-auto-calculo="PROPORCIONES"
        @cantidad-envases-y-kilos-modificada="EventCantidadesModificadas"
      />
      <!-- Separador -->
      <div class="div-elementoSeparador-90" />
      <!-- Pie de  Boton Opciones busqueda -->
      <div class="div-opcionesActions">
        <f7-row>
          <f7-col
            width="50"
            class="col-izquierdaActions"
          >
            <a
              class="link link-izquierdaActions-1"
              @click="CerrarActionDetalle()"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
          </f7-col>
          <f7-col
            width="50"
            class="col-derechaActions"
          >
            <a
              class="link link-derechaActions-1"
              @click="VolcadoParcialMercancia()"
            >
              {{ $t('common.dump').toUpperCase() }}
            </a>
          </f7-col>
        </f7-row>
      </div>
    </f7-actions>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCUnidadMedidaKiloYEnvase from '@/components/common/UCUnitMeasureKiloAndContainer.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import eventBus from '@/js/event-bus'; // Import the EventBus.
import { ConfirmDialogGH, HiDialog, HiNotification } from '@/js/common/HINotificationSupport';

export default {
  name: 'PCVistaVolcarPartida',
  components: {
    UCUnidadMedidaKiloYEnvase,
  },
  props: {
    existenciaSeleccionada: {
      type: Object,
      default: null,
    },
    partidaSeleccionada: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      actionsVolcadoParcial: false,
      cantidadMaximaEnvasesVolcar: 0,
      cantidadMaximaKilosVolcar: 0,
      cantidadEnvasesVolcar: 0, // Mantiene la cantida que se volcara. (parcial o total)
      // partidaSeleccionadaLocal: null,
      validarPartidasAnterioresVolcadoLocal: false,
      actualizarLineasNumeroSerieVolcado: useParamRef('ActualizarLineasNumeroSerieVolcado'),
      trabajarConNumerosDeSerie: useParamRef('trabajarConNumerosDeSerie'),
      comprobarCompatibilidadVolcadoAPedido: useParamRef('ComprobarCompatibilidadVolcadoAPedido'),
      validarPartidasAnterioresVolcado: useParamRef('ValidarPartidasAnterioresVolcado'),
      confirmacionAntesDeVolcar: useSettingRef('Volcado.ConfirmacionAntesDeVolcar'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
      'unidadLogisticaSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, ['partidaSeleccionada']),

    mostrarOpcionesDeVolcadoRecuperadoParcial() {
      return (this.trabajarConNumerosDeSerie && this.actualizarLineasNumeroSerieVolcado) || (!this.trabajarConNumerosDeSerie);
    },
  },

  created() {
    this.InicializarComponente();
    /* this.partidaSeleccionadaLocal = this.partidaSeleccionada;

    this.unidadContendoraSeleccionada = { ...this.unidadLogisticaSeleccionada };
    this.unidadContendoraSeleccionada.Existencias = { ...this.ExistenciasVolcado };
    if (this.unidadContendoraSeleccionada != null && this.unidadContendoraSeleccionada.Existencias != null && this.unidadContendoraSeleccionada.Existencias.length > 0) {
      this.partidaSeleccionadaLocal.Existencias = this.unidadContendoraSeleccionada.Existencias;
    } else { this.CargarExistenciasPorIdentificadorDePartida(); }
 */
    this.ComprobarVolcadoSinConfirmacion();
  },

  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.validarPartidasAnterioresVolcadoLocal = this.validarPartidasAnterioresVolcado; // Solo se comprueba si en ERP esta configurado este parametro.
    },

    /* CargarExistenciasPorIdentificadorDePartida() {
      Log(this, this.CargarExistenciasPorIdentificadorDePartida.name);
      const self = this;
      HiDialog.Preloader(true, 'Cargando Partida...');
      ConexionTA.callObteneElementoDeProduccionPorIdPartida(this.partidaSeleccionadaLocal.Id, true).then((result) => {
        if (result.Valor) {
          // self.ProcesarRespuestaExistenciasPorIdentificadorDePartida(JSON.parse(result.Mensaje));
          self.partidaSeleccionadaLocal = JSON.parse(result.Mensaje);

          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    }, */

    EventCantidadesModificadas(objCantidades) {
      Log(this, this.EventCantidadesModificadas.name);
      if (objCantidades == null) {
        return;
      }
      this.EstablecerCantidadDesDeVolcadoParcial(objCantidades.CantidadKilosModificado, objCantidades.CantidadEnvasesModificado);
    },

    async VolcadoTotalMercancia() {
      Log(this, this.VolcadoTotalMercancia.name);
      this.cantidadEnvasesVolcar = this.existenciaSeleccionada.Cajas;
      if (this.comprobarCompatibilidadVolcadoAPedido) {
        const compativilidadOK = await this.ComprobarCompatibilidadVolcadoAPedido();
        if (!compativilidadOK) {
          return;
        }
      }
      if (this.validarPartidasAnterioresVolcadoLocal) {
        const validarPartidasAnterioresVolcadoOK = await this.ComprobarExistenciaPartidasAnterioresParaVolcado();
        if (!validarPartidasAnterioresVolcadoOK) {
          return;
        }
      }
      this.VolcadoDeMercanciaPorPartida();
    },

    PrepararVolcadoParcial() {
      Log(this, this.PrepararVolcadoParcial.name);
      this.cantidadMaximaEnvasesVolcar = this.existenciaSeleccionada.Cajas;
      this.cantidadMaximaKilosVolcar = this.existenciaSeleccionada.PesoNeto;
      this.actionsVolcadoParcial = true;
    },

    CerrarActionDetalle() {
      Log(this, this.CerrarActionDetalle.name);
      this.actionsVolcadoParcial = false;
    },

    async VolcadoParcialMercancia() {
      Log(this, this.VolcadoParcialMercancia.name);
      this.CerrarActionDetalle();
      if (this.comprobarCompatibilidadVolcadoAPedido) {
        const compativilidadOK = await this.ComprobarCompatibilidadVolcadoAPedido();
        if (!compativilidadOK) {
          return;
        }
      }
      if (this.validarPartidasAnterioresVolcadoLocal) {
        const validarPartidasAnterioresVolcadoOK = await this.ComprobarExistenciaPartidasAnterioresParaVolcado();
        if (!validarPartidasAnterioresVolcadoOK) {
          return;
        }
      }
      this.VolcadoDeMercanciaPorPartida();
    },
    /** Método ComprobarCompatibilidadVolcadoAPedido */
    async ComprobarCompatibilidadVolcadoAPedido() {
      Log(this, this.ComprobarCompatibilidadVolcadoAPedido.name);
      const puntoVolcado = this.puntoDeVolcadoSeleccionado;
      if (!puntoVolcado.AsociarLineaPedido || (!puntoVolcado.LineasPedidoVentaAsociadas || puntoVolcado.LineasPedidoVentaAsociadas.length === 0)) {
        return true;
      }
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.validation.family.preloaderText'));
      const result = await ConexionTA.callComprobarCompatibilidadVolcadoAPedido(this.partidaSeleccionada.Id, puntoVolcado.LineasPedidoVentaAsociadas);
      HiDialog.Preloader(false);
      if (result.Valor) {
        return true;
      }
      HiNotification.Alert(result.Mensaje, this.$t('production.dump.batchDetails.validation.family.errorAlertTitle'));
      return false;
    },
    /** Método ComprobarExistenciaPartidasAnterioresParaVolcado */
    async ComprobarExistenciaPartidasAnterioresParaVolcado() {
      Log(this, this.ComprobarExistenciaPartidasAnterioresParaVolcado.name);
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.validation.previousBatches.preloaderText'));
      // La busqueda puede ser dede UL/NS por lo que disponemos de su Id o directamente desde partida.
      let idArticuloNumeroSerie = 0;
      if (this.unidadLogisticaSeleccionada !== null && this.unidadLogisticaSeleccionada !== undefined) {
        idArticuloNumeroSerie = this.unidadLogisticaSeleccionada.Id;
      }
      const result = await ConexionTA.callComprobarExistenciaPartidasAnterioresParaVolcado(this.partidaSeleccionadaLocal.Id, idArticuloNumeroSerie);
      HiDialog.Preloader(false);
      if (result.Valor) {
        return true;
      }

      const confirmationAlertTitle = this.$t('production.dump.batchDetails.validation.previousBatches.confirmationAlert.title');
      const confirmationAlertText = this.$t('production.dump.batchDetails.validation.previousBatches.confirmationAlert.text');

      return ConfirmDialogGH(confirmationAlertText, confirmationAlertTitle);
    },
    /** Método VolcadoDeMercanciaPorPartida */
    VolcadoDeMercanciaPorPartida() {
      Log(this, this.VolcadoDeMercanciaPorPartida.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.dump.preloaderText'));
      const lineaDeVolcado = this.lineaDeProduccionSeleccionada;
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      const idPartida = this.partidaSeleccionada.Id;
      const articuloNumeroSerieSeleccionado = this.unidadLogisticaSeleccionada;
      // La busqueda puede ser dede UL/NS por lo que disponemos de su Id o directamente desde partida.
      let idArticuloNumeroSerie = 0;
      if (articuloNumeroSerieSeleccionado !== null && articuloNumeroSerieSeleccionado !== undefined) {
        idArticuloNumeroSerie = articuloNumeroSerieSeleccionado.Id;
        // else idArticuloNumeroSerie = this.partidaSeleccionadaLocal.Existencias[0].IdUnidadLogistica; // Busquedas desde partida. Selección de la primera UL/NS
      } else {
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('production.dump.batchDetails.dump.serialNumberRequired.errorToastText'));
        return;
      }
      ConexionTA.callVolcarMercancia(lineaDeVolcado.Id, puntoDeVolcado.Id, idPartida, idArticuloNumeroSerie, this.cantidadEnvasesVolcar).then(async (result) => {
        if (result.Valor) {
          await self.AsociarLineasPedidoVentaVolcado(puntoDeVolcado, idArticuloNumeroSerie);
          self.NotificarVolcadoDeMercancia();
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },
    async AsociarLineasPedidoVentaVolcado(puntoVolcado, idArticuloNumeroSerie) {
      Log(this, this.AsociarLineasPedidoVentaVolcado.name);
      if (!puntoVolcado.AsociarLineaPedido || (!puntoVolcado.LineasPedidoVentaAsociadas || puntoVolcado.LineasPedidoVentaAsociadas.length === 0)) {
        return;
      }
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.associatingSalesOrder.preloaderText'));
      await ConexionTA.callAsociarLineasPedidoVentaVolcadoXUnidadLogistica(puntoVolcado.Id, idArticuloNumeroSerie, puntoVolcado.LineasPedidoVentaAsociadas);
      HiDialog.Preloader(false);
    },

    EstablecerCantidadDesDeVolcadoParcial(cantidadKilos, cantidadEnvases) {
      Log(this, this.EstablecerCantidadDesDeVolcadoParcial.name);
      this.cantidadEnvasesVolcar = cantidadEnvases;
    },

    ComprobarVolcadoSinConfirmacion() {
      Log(this, this.ComprobarVolcadoSinConfirmacion.name);
      if (this.confirmacionAntesDeVolcar) {
        return;
      } // Continuamos el proceso normal.
      this.VolcadoTotalMercancia(); // volcado sin confirmación activo.
    },

    NotificarVolcadoDeMercancia() {
      Log(this, this.NotificarVolcadoDeMercancia.name);
      this.GenerarNoticacion('Mercancia Volcada correctamente');
      eventBus.emit('PCVistaVolcarPartida_mercanciaVolcada');
    },

    GenerarNoticacion(mensaje) {
      HiNotification.Toast(mensaje, 4000);
    },
  },
};
</script>

<style scoped>
.div-componentePCVistaVolcarPartida {
  margin: 15px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-weight: 500;
  font-size: 18px;
}

.span-ttlElemento {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
}

.span-textoElemento {
  color: #009ba6;
  font-size: 14px;
  font-weight: 500;
}

.row {
  padding-right: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.div-opcionesActionsVolcadoParcial {
  padding: 17px;
}

.div-componenteUCUnidadMedidaKiloYEnvase {
  margin-right: 18px;
  margin-top: 0;
  margin-bottom: 18px;
}

.div-opcionesActions {
  width: 94%;
  bottom: 1px;
  position: absolute;
}
</style>
